var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",class:{ skelly: !_vm.init }},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.reinit}},[_vm._v("↺")])])
}
var staticRenderFns = []

export { render, staticRenderFns }